import * as React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Stack, Box, Grid, Checkbox } from '@mui/material'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'

import '../../../App.css'
import '../../../css/modal.scss'
import Modal from '../../common/modal'
import LineInput from '../../common/lineinput'
import { GetActivityUI } from '../../activity'
import { useSearchParams } from 'react-router-dom'
import { Item } from '../../common/snippets'
import {
  getBranchList,
  updateBrnchList,
  updateSendCityList,
  updateStrtBrnch,
  updateStrtCity,
  updateModal,
  getCitiesBranchList,
  getAllStates,
  getCheckingReport,
  getListData,
  UpdateListData
} from '../../../store/common/common_action'
import DropDownOA from '../../common/dropDownOA'
import { getPaymentMode } from '../../common/paymentsMode'
import {
  Transfer_From_City,
  Transfer_From_Branch,
  Select_Destination_City,
  Select_Destination_Branch,
  Booking_Type,
  Consignment_Type,
  STATE,
  From_Booking_Date,
  To_Booking_Date,
  From_Receiving_Date,
  To_Receiving_Date,
} from './Lables'
import Datepicker from '../../common/datePicker'
import SearchIcon from '@mui/icons-material/Search'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { callAddFontNirmalaNormal } from './fonts/Nirmala-normal'
import { callAddFontNirmalaBold } from './fonts/Nirmala-bold'
import autoTable from 'jspdf-autotable'

import jsPDF from 'jspdf'
import moment from 'moment/moment'
import { API_CACHE_DURATION, branchObj, cityObj, Consignmentobj } from '../../common/constants'
import { focusElemnt, isEmpty, navigation1, navigation3 } from '../../common/helper'
const TopSection = ({
  data,
  buttonId,
  setState,
  updateSendCityList,
  updateStrtCity,
  updateBrnchList,
  updateStrtBrnch,
  getBranchList,
  getListData,
  UpdateListData,
  updateModal,
  getCitiesBranchList,
  getAllStates,
  getCheckingReport,
  selelectedData,
  setSelectedData,
  allDataTopSection,
  defaultValueForTop,
  cancelEdit,
  selectedLRS,
  setActive
}) => {
  const [searchParams] = useSearchParams()
  const { common } = data
  const {
    showModal,
    modalType,
    strtCity,
    cityList,
    loginData,
    destCity,
    brnchList,
    strtBrnch,
    strtBrnchList,
    companySettingsL,
    citiesBranchList,
    allStates,
    checkingReport,
    cnsgnmntTypes,companySettings
  } = { ...common }
  // const companySettings = companySettingsL ? companySettingsL[0] : ''
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const [currentView, setCurrentView] = useState(searchParams.get('view') || common.selectedActvty)
  //for active class
  const [activeClass, setActiveClass] = useState({
    BkTransfer: false,
    delTransfer: false,
    bkButton: false,
    selectDestBranchActive: 0,
    whichbtnClick: '',
  })
  const { BkTransfer, delTransfer, bkButton, selectDestBranchActive, whichbtnClick } = activeClass

  //api data
  const [apiData, setApiData] = useState({
    senCNnST: '',
    isScUpdated: false,
  })
  const { senCNnST, isScUpdated, AllState } = apiData
  const [allCities, setAllCities] = useState([])
  // All states
  const [allState, setAllState] = useState({
    dateCheckBox: null,
    bookRadioChacked: null,
    ReceivRadioChacked: null,
    cities: [],
    citiesselectBranches: [],
    citiesselectedBranches: [],
    selectDestBranch: null,
    selectedState: null,
    searchValue: '',
    selectedCities: [],
    transferFor: '',
  })
  const {
    dateCheckBox,
    ReceivRadioChacked,
    bookRadioChacked,
    cities,
    citiesselectBranches,
    citiesselectedBranches,
    selectDestBranch,
    selectedState,
    searchValue,
    selectedCities,
    transferFor,
  } = allState
  const [allSortedState, setAllSortedState] = useState(null)
  const [load, setLoad] = useState(false)
  const [generatePDF, setGeneratePDF] = useState(false)
  const [date, setDate] = useState({
    fromdt: null,
    todt: null,
  })
   const [selectAll, setSelectAll] = useState(false)
   const [allBranches, setAllBranches] = useState(citiesselectBranches); // State for all branches
   
  const [pdfData, setPdfData] = useState([])
  const { fromdt, todt } = date
  const [successModal, setSuccessModal] = useState({
    CHECKINGREPORT: { id: 'CHECKINGREPORT', lrListLabel: 'Checking Report Popup Model', isSaved: false },
    CHECKINGREPORTPrint: { id: 'CHECKINGREPORTPrint', lrListLabel: 'Checking Report Print Popup Model', isSaved: false },
  })
 const [filteredDestBranch, setFilteredDestBranch] = useState([])
  //get numeric months
  function getNumericMonth(monthAbbr) {
    return String(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr) + 1).padStart(
      2,
      '0'
    )
  }

  // All UseEffect
  useEffect(() => {
    if (BkTransfer) setActive(1)
    if (delTransfer) setActive(2)
  }, [BkTransfer, delTransfer])
  useEffect(() => {
    if (!selelectedData?.selectDestCity || selelectedData.selectDestCity === "All") {
      setFilteredDestBranch(allDataTopSection.SelectDestBranch || [])
      return
    }
    const branches = allDataTopSection.SelectDestBranch.filter(
      (item) => item.CityID === selelectedData.selectDestCity.CityID
    )
    setFilteredDestBranch(branches)
    setSelectedData(prev => ({
      ...prev,
      selectDestBranch: "All"
    }))
  }, [selelectedData.selectDestCity, allDataTopSection.SelectDestBranch])
  useEffect(() => {
    const todayDate = new Date().toString().split(' ')
    const year = todayDate[3]
    const day = todayDate[2]
    const month = getNumericMonth(todayDate[1])
    const currentDate = `${year}-${month}-${day}`
    const today = `${day}-${month}-${year}`
    setDate({ ...date, fromdt: currentDate, todt: currentDate })
  }, [])
  useEffect(() => {
    if (cityList.length) {
      const arry = cityList?.map((val) => ({ ...val, checked: false }))
      const uniqueStates = arry.reduce(
        (acc, ele) => {
          if (!acc.seenStateIds.has(ele.StateID)) {
            acc.seenStateIds.add(ele.StateID)
            acc.uniqueStates.push(ele)
          }
          return acc
        },
        { seenStateIds: new Set(), uniqueStates: [] }
      )?.uniqueStates
      const allStateSort = uniqueStates.sort((a, b) => a.StateName.localeCompare(b.StateName))
      setAllSortedState(allStateSort)
      setAllState({ ...allState, selectedState: allStateSort.length ? allStateSort[0] : null })
      setAllCities(arry)
    }
  }, [cityList])
  // console.log("allCities",allCities)
  useEffect(() => {
    if (loginData?.IsSTACargoCompany === 1) {
      const data = citiesselectBranches.concat(citiesBranchList)
      const branches = data.filter((val, i) => val.CargoHasDelivery == 1)
      setAllState({ ...allState, citiesselectBranches: branches })
    } else {
      const data = citiesselectBranches.concat(citiesBranchList)
      setAllState({ ...allState, citiesselectBranches: data })
    }
  }, [citiesBranchList])

  useEffect(() => {
    if (!isEmpty(loginData)) {
      getAllStates(loginData)
      updateSendCityList()
      setActiveClass({ ...activeClass, BkTransfer: true })
      document.getElementById('selectDC').focus()
    }
  }, [loginData])
  useEffect(() => {
    if (showModal) {
      setSelectAll(false);
    }
  }, [showModal]);


  useEffect(() => {
    const data = allCities?.filter((val) => val.StateID == selectedState?.StateID)
    setAllState({ ...allState, cities: data.filter((val, i) => val.CityID !== strtCity.CityID) })
  }, [selectedState])
  // console.log("cities",cities)
  const GroupData = (array) => {
    var newData = {}
    array.forEach((item) => {
      if (!(item['ToBranch'] in newData)) {
        newData[item['ToBranch']] = []
      }
      newData[item['ToBranch']].push({
        FormattedLRNo: item['FormattedLRNo'],
        IsShortReceived: item['IsShortReceived'],
        ActualWeight: item['ActualWeight'],
        BookingDate: item['BookingDate'],
        FromBranch: item['FromBranch'],
        FromCity: item['FromCity'],
        FromCityCode: item['FromCityCode'],
        MOPName: item['MOPName'],
        Quantity: item['Quantity'],
        RecName: item['RecName'],
        Sender: item['Sender'],
        ToCity: item['ToCity'],
        ToCityCode: item['ToCityCode'],
        ToBranch: item['ToBranch'],
        NetAmount: item['NetAmount'],
      })
    })


    let quantityTotal = 0
    let actualweightTotal = 0
    let NetAmountTotal = 0

    Object.keys(newData).map((val) => {
      newData[val].forEach((val) => {
        quantityTotal += Number(val.Quantity)
        actualweightTotal += Number(val.ActualWeight)
        NetAmountTotal += Number(val.NetAmount)
      })
      newData[val].push({
        FormattedLRNo: `Branch Name:${val} `,
        Quantity: quantityTotal,
        ActualWeight: actualweightTotal,
        NetAmount: NetAmountTotal.toFixed(2),
        grossTotal: NetAmountTotal.toFixed(2),
      })

      newData[val].unshift({ FormattedLRNo: `City Name :` + newData[val][0].ToCity, ToCity: `Destination Branch Name : ` + val })
      quantityTotal = 0
      actualweightTotal = 0
      NetAmountTotal = 0
    })
    const mainData = { ...newData }
    let bodyData = []
    Object.keys(mainData)?.map((item) => {
      const data = [...bodyData]
      bodyData = [...data, ...mainData[item]]
    })
    // console.log(4569787, bodyData)
    return bodyData
  }
  const CityWiseGroupData = (array) => {
    if (array.length >= 1) {
      var newData = {}
      array?.forEach((item) => {
        if (!(item['ToCity'] in newData)) {
          newData[item['ToCity']] = []
        }
        newData[item['ToCity']].push({
          FormattedLRNo: item['FormattedLRNo'],
          IsShortReceived: item['IsShortReceived'],
          ActualWeight: item['ActualWeight'],
          BookingDate: item['BookingDate'],
          FromBranch: item['FromBranch'],
          FromCity: item['FromCity'],
          FromCityCode: item['FromCityCode'],
          MOPName: item['MOPName'],
          Quantity: item['Quantity'],
          RecName: item['RecName'],
          Sender: item['Sender'],
          ToCity: item['ToCity'],
          ToCityCode: item['ToCityCode'],
          ToBranch: item['ToBranch'],
          NetAmount: item['NetAmount'],
        })
      })
      let data = []
      let quantityTotal = 0
      let actualweightTotal = 0
      let NetAmountTotal = 0
      // console.log("groupdata",newData)
      Object.keys(newData)?.forEach((val) => {
        const arr = GroupData(newData[val])
        const dataFilter = arr?.filter((item) => Object.keys(item).length === 5)
        // console.log("filtered",dataFilter)
        dataFilter?.forEach((val) => {
          quantityTotal += Number(val.Quantity)
          actualweightTotal += Number(val.ActualWeight)
          NetAmountTotal += Number(val.NetAmount)
        })
        arr.push({
          FormattedLRNo: `City Name:${newData[val][0].ToCity} `,
          Quantity: quantityTotal,
          ActualWeight: actualweightTotal,
          NetAmount: NetAmountTotal.toFixed(2),
        })
        quantityTotal = 0
        actualweightTotal = 0
        NetAmountTotal = 0
        data = [...data, ...arr]
      })
      const totalData = data?.filter((item) => Object.keys(item).length === 4)
      let TotalquantityTotal = 0
      let TotalNetAmount = 0
      let TotalactualweightTotal = 0
      totalData.map((item) => (TotalquantityTotal += Number(item?.Quantity)))
      totalData.map((item) => (TotalNetAmount += Number(item?.ActualWeight)))
      totalData.map((item) => (TotalactualweightTotal += Number(item?.NetAmount)))

      data.push({
        FormattedLRNo: 'Grand Total',
        Quantity: TotalquantityTotal,
        ActualWeight: TotalNetAmount,
        NetAmount: TotalactualweightTotal.toFixed(2),
      })
      // console.log(2345, data)
      setPdfData(data)
    } else {
      setPdfData([])
    }
  }
  useEffect(() => {
    if (checkingReport.status === "Success") {
      CityWiseGroupData(checkingReport?.Data?.Table)
    }

  }, [checkingReport])

  //after


  useEffect(() => {
    if (selelectedData.selectDestCity?.CityID) {
      getBranchList(loginData, selelectedData.selectDestCity?.CityID, 2, true, API_CACHE_DURATION)
    }
  }, [selelectedData.selectDestCity?.CityID])

  useEffect(() => {
    if (cityList.length > 0) {
      const sC = cityList?.find(({ CityID }) => CityID == loginData.intBranchCityID)
      if (sC) {
        updateStrtCity(sC)
        if (!isScUpdated) {
          setApiData({ ...apiData, senCNnST: destCity.CityName + `, ${destCity.StateName}`, isScUpdated: true })
        }
        setApiData({ ...apiData, senCNnST: sC.CityName + `, ${sC.StateName}` })
      }
    }
  }, [cityList])

  useEffect(() => {
    if (brnchList.length > 0) {
      updateStrtBrnch(brnchList.find(({ BranchID }) => BranchID == loginData.intBranchID) || {})
      updateBrnchList(brnchList, 1)
    }
  }, [brnchList])

   const handleSelectAll = (e) => {
      setSelectAll(e.target.checked);
      if (e.target.checked) {
        // Move all branches to the selected list
        setAllState((prevState) => ({
          ...prevState,
          citiesselectedBranches: [...citiesselectBranches], // Move all to selected
          citiesselectBranches: [], // Clear the left side
        }));
      } else {
        // If unchecking, restore the selected branches back to the left side
        setAllState((prevState) => ({
          ...prevState,
          citiesselectedBranches: [], // Clear the selected
          citiesselectBranches: [...allBranches, ...prevState.citiesselectedBranches], // Restore the left side
        }));
      }
    };
  
    // Update the state when citiesselectBranches changes
    useEffect(() => {
      setAllBranches(citiesselectBranches);
    }, [citiesselectBranches])
  //for all onClick
  const handleActive = (id, e) => {
    switch (id) {
      case 'Booking':
        setActiveClass({ ...activeClass, BkTransfer: true, delTransfer: false, whichbtnClick: id })
        setSelectedData({ ...selelectedData, selectedButtonType: id })
        document.getElementById('selectDC').focus()
        setState({ showListTable: false, showListAllTable: false })
        break
      case 'Delivery':
        setActiveClass({ ...activeClass, BkTransfer: false, delTransfer: true, bkButton: false, whichbtnClick: id })
        setSelectedData({ ...selelectedData, selectedButtonType: id })
        document.getElementById('selectDC').focus()
        setState({ showListTable: false, showListAllTable: false })

        break
      case 'showlist':
        UpdateListData([])
        const object = {
          CurrentCityID: strtCity.CityID,
          CurrentBranchID: strtBrnch.BranchID,
          IsBranchTransfer: selelectedData.selectedButtonType === 'Booking' || selelectedData.selectedButtonType === undefined ? 1 : 0,
          BranchID: selelectedData.selectDestBranch === 'All' || selelectedData.selectDestBranch === undefined ? 0 : selelectedData.selectDestBranch?.BranchID,
          CityID: selelectedData.selectDestCity === 'All' || selelectedData.selectDestCity === undefined ? 0 : selelectedData.selectDestCity?.CityID,
          PaymentTypeID: selelectedData.selectBookingtype === 'All' || selelectedData.selectBookingtype === undefined ? 0 : selelectedData.selectBookingtype?.typeId,
          ConsignmentSubTypeID: selelectedData.selectconsignmentType === 'All' || selelectedData.selectconsignmentType === undefined ? 0 : selelectedData.selectconsignmentType?.ConsignmentSubTypeID,
        }
        getListData(loginData, object)
        selectedLRS([])
        setState({ showListTable: true, showListAllTable: false })
        break
      case 'CHECKINGREPORT':
        const todayDate = new Date().toString().split(' ')
        const year = todayDate[3]
        const day = todayDate[2]
        const month = getNumericMonth(todayDate[1])
        const currentDate = `${year}-${month}-${day}`
        setDate({ ...date, fromdt: currentDate, todt: currentDate })
        const citiesName = allCities.filter((val) => val.StateID == allSortedState[0]?.StateID)
        const array = allCities?.map((val) => ({ ...val, checked: false }))
        const secondcities = citiesName?.filter((val, i) => val.CityID !== strtCity.CityID)
        const filteredcities = secondcities.map((val) => ({ ...val, checked: false }))
        setAllCities(array)
        setAllState({ ...allState, citiesselectedBranches: [], selectedState: allSortedState[0], citiesBranchList: [], selectedCities: [], citiesselectBranches: [], dateCheckBox: false, cities: filteredcities })
        updateModal(true, 'CHECKINGREPORT')
        break
      case 'showListAll':
        UpdateListData([])
        const showlistAllData = {
          CurrentCityID: strtCity.CityID,
          CurrentBranchID: strtBrnch.BranchID,
          IsBranchTransfer: selelectedData.selectedButtonType === 'Booking' || selelectedData.selectedButtonType === undefined ? 1 : 0,
          BranchID: selelectedData.selectDestBranch === 'All' || selelectedData.selectDestBranch === undefined ? 0 : selelectedData.selectDestBranch?.BranchID,
          CityID: selelectedData.selectDestCity === 'All' || selelectedData.selectDestCity === undefined ? 0 : selelectedData.selectDestCity?.CityID,
          PaymentTypeID: selelectedData.selectBookingtype === 'All' || selelectedData.selectBookingtype === undefined ? 0 : selelectedData.selectBookingtype?.typeId,
          ConsignmentSubTypeID: selelectedData.selectconsignmentType === 'All' || selelectedData.selectconsignmentType === undefined ? 0 : selelectedData.selectconsignmentType?.ConsignmentSubTypeID,
        }
        getListData(loginData, showlistAllData)
        selectedLRS([])
        setState({ showListTable: true, showListAllTable: true })
        break
      case 'LeftIcon':
        if (selectDestBranch !== null) {
          const leftBranch = citiesselectBranches.filter((val) => val.BranchID !== selectDestBranch.BranchID)
          citiesselectedBranches.unshift(selectDestBranch)
          setAllState({ ...allState, citiesselectBranches: leftBranch, selectDestBranch: null })
          setActiveClass({ ...activeClass, selectDestBranchActive: null })
        }
        break
      case 'RightIcon':
        if (selectDestBranch !== null) {
          const RightBranch = citiesselectedBranches.filter((val) => val.BranchID !== selectDestBranch.BranchID)
          citiesselectBranches.unshift(selectDestBranch)
          setAllState({ ...allState, citiesselectedBranches: RightBranch, selectDestBranch: null })
          setActiveClass({ ...activeClass, selectDestBranchActive: null })
        }
        break
      case 'citiesBranch':
        setAllState({ ...allState, selectDestBranch: e })
        setActiveClass({ ...activeClass, selectDestBranchActive: e.BranchID })
        break
      case 'citiesSelBranch':
        setAllState({ ...allState, selectDestBranch: e })
        setActiveClass({ ...activeClass, selectDestBranchActive: e.BranchID })
        break
      case 'Generate':
        setLoad(false)
        setGeneratePDF(false)
        const brnch = citiesselectedBranches.map((val) => val.BranchID)
        const selbrnch = brnch.join('^').toString()
        const data = {
          intFromCityID: strtCity?.CityID,
          intFromBranchID: strtBrnch.BranchID,
          strToCityIDs: 0,
          strToBranchIDs: selbrnch,
          isDtWise: dateCheckBox === true ? 1 : 0,
          isbkgDtwise: bookRadioChacked === true ? 1 : 0,
          fromdt: fromdt,
          todt: todt,
        }
        getCheckingReport(loginData, data)
        updateModal(true, 'CHECKINGREPORTPrint')
        break
      case 'GeneratePrint':
        printClick()
        break
      case 'GeneratePrintClose':
        updateModal(false, 'CHECKINGREPORTPrint')
        break
      default:
        break
    }
  }

  const printClick = () => {
    setLoad(true)
    setGeneratePDF(true)
    jsPDF.API.events.push(['addFonts', callAddFontNirmalaBold])
    jsPDF.API.events.push(['addFonts', callAddFontNirmalaNormal])
    const HeaderColumn = [
      {
        headerName: 'From Date',
        exportHead: 'From Date',
        field: 'FromDate',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'To Date',
        exportHead: 'To Date',
        field: 'ToDate',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Report For',
        exportHead: 'Report For',
        field: 'ReportFor',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Cities',
        exportHead: 'Cities',
        field: 'cities',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: ' Branches',
        exportHead: ' Branches',
        field: 'branch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
    ]
    const secondColumn = [
      {
        headerName: 'City Name',
        exportHead: 'City Name',
        field: 'ToCity',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Quantity',
        exportHead: 'NOP',
        field: 'Quantity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Actual Weight',
        exportHead: 'Actual Weight',
        field: 'ActualWeight',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },

      {
        headerName: 'Net Amount',
        exportHead: 'Net Amount',
        field: 'NetAmount',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
    ]

    const HeaderData = [
      {
        FromDate: dateCheckBox == true ? fromdt : 'All',
        ToDate: dateCheckBox == true ? todt : 'All',
        cities: selectedCities?.length == 1 ? selectedCities[0]?.CityName : 'Multiple Cities',
        branch: citiesselectedBranches.length == 1 ? citiesselectedBranches[0]?.BranchName : 'Multiple Branches',
        ReportFor: transferFor === '' || dateCheckBox == false ? 'All' : transferFor,
      },
    ]
    const columnDefs = [
      {
        headerName: 'LRNo',
        exportHead: 'LRNo',
        field: 'FormattedLRNo',
        xlCol: { dataType: 'number', dataFormatter: null },
      },
      {
        headerName: 'Booking Date',
        exportHead: 'Booking Date',
        field: 'BookingDate',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Source City',
        exportHead: 'Source City',
        field: 'FromCity',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Source Branch',
        exportHead: 'Source Branch',
        field: 'FromBranch',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Sender Name',
        exportHead: 'Sender Name',
        field: 'Sender',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Dest. City',
        exportHead: 'Dest. City',
        field: 'ToCity',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Dest. Branch',
        exportHead: 'Dest. Branch',
        field: 'ToBranch',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },

      {
        headerName: 'Receiver Name',
        exportHead: 'Receiver Name',
        field: 'RecName',
        xlCol: { dataType: 'string', dataFormatter: null },
      },

      {
        headerName: 'MOPName',
        exportHead: 'Cons.Type',
        field: 'MOPName',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
      {
        headerName: 'Quantity',
        exportHead: 'NOP',
        field: 'Quantity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Actual Weight',
        exportHead: 'Actual Weight',
        field: 'ActualWeight',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },

      {
        headerName: 'Net Amount',
        exportHead: 'Net Amount',
        field: 'NetAmount',
        xlCol: { dataType: 'quantity', dataFormatter: null },
      },
    ]

    const pdfColumns = columnDefs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = HeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const cityWise = secondColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })

    const doc = new jsPDF()

    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'left', fillColor: [30, 89, 167] },
    })

    doc.setProperties({
      title: `Transfer.pdf`,
      subject: 'Transfer Summary Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Transfer',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 19, left: 5, right: 5, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { halign: 'left', font: 'Nirmala', fontSize: 8 },
        1: { fontSize: 8, font: 'Nirmala', halign: 'left' },
        2: { fontSize: 8, font: 'Nirmala', halign: 'left' },
        3: { fontSize: 8, font: 'Nirmala', halign: 'left' },
        4: { fontSize: 8, font: 'Nirmala', halign: 'left' },
      },
      theme: 'grid',
      headStyles: {
        fillColor: [30, 89, 167],
      },
    })

    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc

      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
      doc.setDrawColor(0, 0, 0)
      doc.setLineWidth(0.2)
      doc.line(0, pageHeight - 7, pageWidth, pageHeight - 7)
      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(9)
      doc.text(str, 5 + 260, pageHeight - 2)
      doc.setFont('Nirmala', 'normal')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 5, pageHeight - 2)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, 5 + 150, pageHeight - 2)
    }

    let drawCell = function (data) {
      const pdoc = data.doc
      var rows = data.table.body

      rows.map((val) => {
        if (Object.keys(val.raw).length == 2) {
          val.cells[0].colSpan = 5
          val.cells[0].styles.font = 'Nirmala'
          val.cells[0].styles.fontStyle = 'bold'
          val.cells[0].styles.fontSize = '7'
          val.cells[0].styles.fillColor = [244, 250, 254]

          val.cells[5].colSpan = 7
          val.cells[5].styles.font = 'Nirmala'
          val.cells[5].styles.fontStyle = 'bold'
          val.cells[5].styles.fontSize = '7'
          val.cells[5].styles.fillColor = [244, 250, 254]
        }
      })
      rows.map((val) => {
        if (Object.keys(val.raw).length == 4 || Object.keys(val.raw).length == 5) {
          val.cells[0].colSpan = 9
          val.cells[0].styles.font = 'Nirmala'
          val.cells[0].styles.fillColor = [208, 220, 238]
          val.cells[0].styles.fontSize = '9'
          val.cells[0].styles.halign = 'right'
          val.cells[0].styles.fontStyle = 'bold'

          val.cells[9].colSpan = 1
          val.cells[9].styles.font = 'Nirmala'
          val.cells[9].styles.fontSize = '6'
          val.cells[9].styles.halign = 'right'
          val.cells[9].styles.fontStyle = 'bold'
          val.cells[9].styles.fillColor = [208, 220, 238]

          val.cells[10].colSpan = 1
          val.cells[10].styles.font = 'Nirmala'
          val.cells[10].styles.fontSize = '6'
          val.cells[10].styles.halign = 'right'
          val.cells[10].styles.fontStyle = 'bold'
          val.cells[10].styles.fillColor = [208, 220, 238]

          val.cells[11].colSpan = 1
          val.cells[11].styles.font = 'Nirmala'
          val.cells[11].styles.fontSize = '6'
          val.cells[11].styles.halign = 'right'
          val.cells[11].styles.fontStyle = 'bold'
          val.cells[11].styles.fillColor = [208, 220, 238]
        }
      })
    }


    var totalPagesExp = '{total_pages_count_string}'
    autoTable(doc, {
      margin: { top: 19, left: 5, right: 5, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
        0: { colspan: 8, minRowWidth: 60 },
      },
      columns: pdfColumns,
      body: pdfData,
      columnStyles: {
        0: { halign: 'left', minCellWidth: 2, font: 'Nirmala', fontSize: 7 },
        1: { minCellWidth: 12, fontSize: 7, font: 'Nirmala', halign: 'left' },
        2: { minCellWidth: 15, fontSize: 7, font: 'Nirmala', halign: 'left' },
        3: { fontSize: 7, font: 'Nirmala', minCellWidth: 30, halign: 'left' },
        4: { minCellWidth: 12, fontSize: 7, font: 'Nirmala', halign: 'left' },
        5: { minCellWidth: 16, fontSize: 7, font: 'Nirmala', halign: 'left' },
        6: { minCellWidth: 26, font: 'Nirmala', fontSize: 7 },
        7: { minCellWidth: 12, font: 'Nirmala', fontSize: 7 },
        8: { minCellWidth: 10, font: 'Nirmala', fontSize: 7 },
        9: { fontSize: 7, minCellWidth: 10, font: 'Nirmala', halign: 'right' },
        10: { fontSize: 7, minCellWidth: 10, font: 'Nirmala', halign: 'right' },
        11: { fontSize: 7, minCellWidth: 10, font: 'Nirmala', halign: 'right' },
      },
      theme: 'grid',
      headStyles: {
        fillColor: [30, 89, 167],
      },
      didParseCell: (data) => {
        drawCell(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 5, 8, 8, 8)
        doc.setFontSize(11)
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System', 15, 14)
        doc.setDrawColor(16, 79, 162)
        doc.setLineWidth(0.4)
        doc.line(43, 11, 43, 15)

        doc.setFontSize(11)
        doc.setTextColor(16, 79, 162)
        // doc.text(`Summary View - Check-in Report for Branch Transfer`, 48, 14)
        doc.text(`Check-in Report for Branch Transfer`, 45, 14)
        doc.setFontSize(10).setFont(undefined, 'bold')
        doc.setTextColor(0, 0, 0)
        doc.text('Company Name : ', 130, 14)
        doc.setFontSize(9).setFont(undefined, 'normal')
        doc.text(loginData?.strCompanyName, 160, 14)

        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })



    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    setTimeout(() => {
      setGeneratePDF(false)
      document.getElementById('output').data = doc.output('datauristring', 'printGenerate.pdf')
    }, 2000)
  }

  const PopupClose = (id) => {
    switch (id) {
      case 'CHECKINGREPORT':
        updateModal(false, 'CHECKINGREPORT')
        break
      default:
        break
    }
  }

  //for all onKeyDown
  const onKeyDownn = (e) => {
    if (e.key === 'Escape') {
      document.getElementById('selectCT').focus()
    } else if (e.key === 'Enter') {
      setState({ showListTable: true })
    }
  }
  //for All Onchange
  const onChange = (e, id) => {
    switch (id) {
      case 'DateWise':
        setAllState({ ...allState, dateCheckBox: e.target.checked })
        break
      case 'BookingDate':
        setAllState({ ...allState, bookRadioChacked: e.target.checked, ReceivRadioChacked: false, transferFor: e.target.name })
        break
      case 'ReceiveDate':
        setAllState({ ...allState, ReceivRadioChacked: e.target.checked, bookRadioChacked: false, transferFor: e.target.name })
        break
      case 'cities':
        if (e.target.checked == true) {
          allCities.map((val) => (val.CityID === Number(e.target.id) ? (val.checked = true) : ''))
          cities.map((val) => (val.CityID === Number(e.target.id) ? (val.checked = true) : ''))
          const selcity = cities.filter((val) => val.CityName === e.target.value)
          const city = [...selectedCities, ...selcity]
          setAllState({ ...allState, selectedCities: city })
          getCitiesBranchList(loginData, e.target.id, 2)
        } else {
          allCities.map((val) => (val.CityID === Number(e.target.id) ? (val.checked = false) : ''))
          cities.map((val) => (val.CityID === Number(e.target.id) ? (val.checked = false) : ''))
          const selectBranch = citiesselectBranches.filter((val) => val.CityID != e.target.id)
          const selcity = selectedCities.filter((val) => val.CityName !== e.target.value)
          // selcity.map((val) => (val.CityID ===  e.target.id ? (val.checked = false) : ''))
          setAllState({ ...allState, citiesselectBranches: selectBranch, selectedCities: selcity })
        }

        break
      case 'serchCities':
        setAllState({ ...allState, searchValue: e.target.value })
        break
      case 'firstDate':
        const Todate = e?._d?.toString()?.split(' ')
        const year = Todate?.[3]
        const day = Todate?.[2]
        const month = getNumericMonth(e?._d?.toString()?.split(' ')?.[1])
        const currentDate = `${year}-${month}-${day}`
        setDate({ ...date, fromdt: currentDate })
        break
      case 'secondDate':
        const Todate2 = e?._d?.toString()?.split(' ')
        const year2 = Todate2?.[3]
        const day2 = Todate2?.[2]
        const month2 = getNumericMonth(e?._d?.toString()?.split(' ')?.[1])
        const currentDate2 = `${year2}-${month2}-${day2}`
        setDate({ ...date, todt: currentDate2 })

        break
      default:
        break
    }
  }
  //All Popup
  const CheckingReport = (isRecve = false) => {
    return (
      <Modal headTxt={`Show Consignment in My Branch`} width={'920px'} updateModal={updateModal}>
        <Stack className="modalHeaderMenus">
          <Box className="headerWrapper">
            <Item className="checkingItem">
              <input type="checkbox" onChange={(e) => onChange(e, 'DateWise')} checked={dateCheckBox} />
              <span>Date Wise </span>
            </Item>
            {dateCheckBox ? (
              <>
                <Item className="checkingItem">
                  <input
                    type="radio"
                    checked={bookRadioChacked}
                    name="Booking Date"
                    disabled={dateCheckBox ? false : true}
                    onChange={(e) => onChange(e, 'BookingDate')}
                  />
                  <span>Booking Date </span>
                </Item>
                <Item className="checkingItem">
                  <input
                    type="radio"
                    checked={ReceivRadioChacked}
                    name="Receiving Date"
                    disabled={dateCheckBox ? false : true}
                    onChange={(e) => onChange(e, 'ReceiveDate')}
                  />
                  <span> Receiving Date </span>
                </Item>
                <Item sx={{ background: '#e1f2fe' }}>
                  <div className="input--container date-picker" style={{ width: '100%' }}>
                    <Datepicker
                      className="deliver-date-picker"
                      name={'filter_from_dt'}
                      type="filter_from_dt"
                      statusChecked={dateCheckBox ? false : true}
                      label={ReceivRadioChacked ? From_Receiving_Date : From_Booking_Date}
                      dateChange={(date) => {
                        onChange(date, 'firstDate')
                      }}
                    />
                  </div>
                </Item>
                <Item sx={{ background: '#e1f2fe' }}>
                  <div className="input--container date-picker" style={{ width: '100%' }}>
                    <Datepicker
                      className="deliver-date-picker"
                      name={'filter_from_dt'}
                      type="filter_from_dt"
                      statusChecked={dateCheckBox ? false : true}
                      label={ReceivRadioChacked ? To_Receiving_Date : To_Booking_Date}
                      dateChange={(date) => {
                        onChange(date, 'secondDate')
                      }}
                    />
                  </div>
                </Item>
              </>
            ) : (
              ''
            )}
          </Box>

        </Stack>
        <Stack className="checkingReportModal">
          <Grid container spacing={2}>
            <Grid item xs={6} md={3} className="destinationBorder">
              <Box className="filterBox">
                <Box>
                  <p className="filterHeading">Select Destination State & City</p>
                </Box>
                <Box>
                  <DropDownOA
                    key={`select_consigner`}
                    type={STATE}
                    label={'State '}
                    data={allSortedState || []}
                    width="100%"
                    searchPlaceholder={'Search State '}
                    isObjArr={true}
                    dataKey={`StateName`}
                    idKey={`StateID`}
                    id="AllStateofBranchTransfer"
                    setAllValue={setAllState}
                    allValues={allState}
                    defaultvalue={selectedState?.StateName}
                    onSelect={(selectedState) =>
                      setAllState({
                        ...allState,
                        selectedState,
                        cities: allCities.filter((val) => val.StateID == selectedState?.StateID),
                      })
                    }
                  />
                </Box>
                <Box className="searchWrapper">
                  <SearchIcon className="searchIcon" />
                  <input type="text" placeholder="Search Cities " onChange={(e) => onChange(e, 'serchCities')} value={searchValue} />
                </Box>


                <Box className="checkboxList">
                  {cities
                    .filter((val) => val.CityName.toLowerCase().includes(searchValue.toLowerCase()))
                    .map((val, i) => {
                      return (
                        <Box style={{ display: 'flex' }} className="checkboxWrapper" key={i}>
                          <input
                            type="checkbox"
                            name="cities"
                            id={val.CityID}
                            value={val.CityName}
                            checked={val.checked}
                            onChange={(e) => onChange(e, 'cities')}
                          />
                          <div>{val.CityName}</div>
                        </Box>
                      )
                    })}
                </Box>
              </Box>
            </Grid>
            {/* <hr/> */}
            <Grid item xs={6} md={9}>
              <Box className="filterBox branchFilterBox" style={{ display: 'flex' }}>
                <Item className="branchFilerWrapper">
                  <Box style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start' }}>
                    <p className="filterHeading" style={{ margin: 0 }}>Select Destination Branch</p>
                    <div style={{ display: 'flex', alignItems: 'flex-start', marginLeft: '15px' }}>
                      <Checkbox
                        id={`selectAllOption`}
                        checked={selectAll}
                        onChange={(e) => {
                          handleSelectAll(e)
                        }}
                        disabled={false}
                        onKeyDown={(e) => {
                        }}
                        style={{ verticalAlign: 'top', paddingTop: '0px', marginTop: '0px' }} // Adjust vertical alignment
                      />
                      <span style={{ marginLeft: '8px', alignSelf: 'flex-start' }}>Select All</span>
                    </div>
                  </Box>
                  <Box className="checkboxList branchList">
                    {citiesselectBranches?.map((val, i) => {
                      return (
                        <>
                          <Box
                            key={i}
                            style={{ display: 'flex' }}
                            className={`checkboxWrapper ${selectDestBranchActive == val.BranchID ? 'selectDeBranchActive' : ''}`}
                          >
                            <div style={{ cursor: 'pointer' }} onClick={() => handleActive('citiesBranch', val)}>
                              {val.BranchName}
                            </div>
                          </Box>
                        </>
                      )
                    })}
                  </Box>
                </Item>
                <Item className="branchShiftWrapper">

                  <div
                    style={{
                      position: 'relative',
                      border: '3px solid white',
                      height: '40px',
                      width: '40px',
                      background: '#0086ff',
                      display: 'flex',
                      alignItems: 'center',
                      borderRadius: '50%',
                      cursor: 'pointer',
                    }}
                    onClick={() => handleActive('LeftIcon')}
                  >
                    <span
                      style={{
                        position: 'absolute',
                        left: '10px',
                        right: '10px',
                        top: '50%',
                        height: '2px',
                        zIndex: 1,
                      }}
                    />
                    <span
                      className="next-arr"
                      style={{
                        transform: 'rotate(0deg)',
                        color: '#fff',
                        right: '7px',
                        position: 'absolute',
                        top: '7px',
                      }}
                    >
                      <PlayArrowIcon />
                    </span>
                  </div>
                  <div
                    style={{
                      position: 'relative',
                      border: '3px solid white',
                      height: '40px',
                      width: '40px',
                      background: '#0086ff',
                      display: 'flex',
                      alignItems: 'center',
                      borderRadius: '50%',
                      cursor: 'pointer',
                    }}
                    onClick={() => handleActive('RightIcon')}
                  >
                    <span
                      style={{
                        position: 'absolute',
                        left: '10px',
                        right: '10px',
                        top: '50%',
                        height: '2px',
                        zIndex: 1,
                      }}
                    />
                    <span
                      className="next-arr"
                      style={{
                        transform: 'rotate(180deg)',
                        color: '#fff',
                        right: '7px',
                        position: 'absolute',
                        top: '2px',
                      }}
                    >
                      <PlayArrowIcon />
                    </span>
                  </div>
                </Item>
                <Item className="branchFilerWrapper">
                  <p className="filterHeading">Selected Destination Branches</p>
                  <Box className="checkboxList branchList ">
                    {citiesselectedBranches?.map((val, i) => {
                      return (
                        <>
                          <Box
                            key={i}
                            style={{ display: 'flex' }}
                            className={`checkboxWrapper ${selectDestBranchActive == val.BranchID ? 'selectDeBranchActive' : ''}`}
                          >
                            <div style={{ cursor: 'pointer' }} onClick={() => handleActive('citiesSelBranch', val)}>
                              {val.BranchName}
                            </div>
                          </Box>
                        </>
                      )
                    })}
                  </Box>
                </Item>
              </Box>
            </Grid>
          </Grid>
        </Stack>
        <hr className="dividerWrapper" />
        <Stack>
          <div className="modal-btn-grp2">

            <Button
              className="select-lr-btn2"
              variant="outlined"
              color="error"
              style={{ cursor: 'pointer' }}
              onClick={() => PopupClose('CHECKINGREPORT')}
            >
              Cancel
            </Button>
            <Button
              className="select-lr-btn3"
              disabled={citiesselectedBranches.length <= 0 ? true : false}
              variant="contained"
              color="error"
              style={{ cursor: 'pointer' }}
              onClick={() => handleActive('Generate')}
            >
              Generate
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const CheckingReportPrint = () => {
    return (
      <Modal headTxt={`Show Consignment in My Branch`} width={load ? '90%' : '25%'} updateModal={updateModal}>
        {load == true ? (
          ''
        ) : (
          <>
            <Stack>
              <Box style={{ margin: '20px', fontSize: '16px' }}>
                <div>Do you want to Generate Print ?</div>
              </Box>
            </Stack>
            <Stack>
              <div className="modal-btn-grp">
                <button
                  autoFocus
                  id="deliveryyes"
                  style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
                  onClick={() => handleActive('GeneratePrint')}
                >
                  YES
                </button>

                <Button
                  className="select-lr-btn"
                  variant="outlined"
                  color="error"
                  onClick={() => handleActive('GeneratePrintClose')}
                  style={{ cursor: 'pointer', fontSize: '12px' }}
                >
                  NO
                </Button>
              </div>
            </Stack>
          </>
        )}
        {generatePDF == true ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
        {load == true ? (
          <object
            id="output"
            type="application/pdf"
            width="1330"
            height="600"
            title="MTLPL -Cargo System - After Generate Summary Report"
            aria-label="MTLPL -Cargo System - After Generate Summary Report"
          ></object>
        ) : (
          ''
        )}
      </Modal>
    )
  }
  return (
    <>
      <Stack
        direction="row"
        divider={
          <Divider
            orientation="vertical"
            sx={{
              width: '2px',
              margin: '14px -16px 0px 0px !important',
              backgroundColor: '#0086ff',
            }}
            flexItem
          />
        }
        spacing={2}
        sx={{ background: '#FFF' }}
      >
        <Item sx={{ width: '100%', paddingBottom: '0px', paddingTop: '16px' }}>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            {GetActivityUI(currentView)}
            <Item sx={{ width: '100%' }}>
              <DropDownOA
                type={Transfer_From_City}
                defaultvalue={allDataTopSection.transferFromCity || ''}
                data={cityList || []}
                width="100%"
                searchPlaceholder={`Search ${Transfer_From_City}`}
                label={Transfer_From_City}
                disabled
                tabIndex="2"
              />
            </Item>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '50%' }}>
              <Button
                id={buttonId}
                sx={{
                  justifyContent: 'flex-start',
                  border: BkTransfer ? '2px solid #0086ff' : bkButton ? '2px solid #0086ff' : '1px solid grey',
                  backgroundColor: cancelEdit == true ? '#e0e0e0' : '',
                  width: '100%',
                }}
                autoFocus={true}
                onClick={() => handleActive('Booking')}
                disabled={cancelEdit == true ? true : false}
                tabIndex={0}
                onKeyDown={(e) => navigation3(e, 'bkbutton', 'activitytype', () => { })}
              >
                <LineInput type="radio" checked={BkTransfer} autoFocus={BkTransfer} />

                <span
                  style={{
                    fontSize: '14px',
                    paddingLeft: '8px',
                    fontWeight: '500',
                    color: 'black',
                    border: '0px',
                    textTransform: 'none',
                  }}
                >
                  Booking Transfer to Another Branch
                </span>
              </Button>
            </Item>
            <Item sx={{ width: '50%', paddingBottom: '0px' }}>

              <DropDownOA
                type={Transfer_From_Branch}
                label={Transfer_From_Branch}
                defaultvalue={allDataTopSection.transferFromBranch || ''}
                data={strtBrnchList || []}
                width="100%"
                searchPlaceholder={`Search ${Transfer_From_Branch}`}
                disabled
                tabIndex="3"
              />
            </Item>

            <Item
              sx={{
                width: '50px',
                display: 'inline-flex',
                padding: '0% 5px',
                height: '50px',
                marginLeft: '-48px !Important',
                marginRight: '0px !Important',
              }}
            >

              <div
                style={{
                  position: 'relative',
                  top: '4px',
                  left: '45px',
                  border: '3px solid white',
                  height: '40px',
                  width: '40px',
                  background: '#0086ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  color: 'white',
                }}
              >
                <ArrowForwardIcon />
              </div>
            </Item>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '50%' }}>
              <Button
                id={buttonId}
                sx={{
                  justifyContent: 'start',
                  border: delTransfer ? '2px solid #0086ff' : '1px solid grey',
                  cursor: 'pointer',
                  width: '100%',
                  backgroundColor: cancelEdit == true ? '#e0e0e0' : '',
                }}
                autoFocus={true}
                onClick={() => handleActive('Delivery')}
                disabled={cancelEdit == true ? true : false}
              >
                <LineInput type="radio" checked={delTransfer} />

                <span
                  style={{
                    fontSize: '14px',
                    paddingLeft: '8px',
                    fontWeight: '500',
                    color: 'black',
                    border: '0px',
                    textTransform: 'none',
                  }}
                >
                  Delivery Transfer to Another Branch
                </span>
              </Button>
            </Item>
          </Box>
        </Item>
        <Item sx={{ width: '100%', paddingBottom: '0px', paddingTop: '16px' }}>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item
              sx={{
                width: '50%',
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
                border: delTransfer ? '2px solid #0086ff' : '1px solid grey',
                margin: '9px',
                height: '39px',
                width: '400px',
                backgroundColor: cancelEdit == true ? '#e0e0e0' : '',
              }}
              onClick={() => handleActive('sourceCity')}
              disabled={cancelEdit == true ? true : false}
            >
              <LineInput type="radio" checked={delTransfer} />

              <span
                style={{
                  fontSize: '14px',
                  paddingLeft: '8px',
                  fontWeight: '500',
                  color: 'black',
                }}
              >
                Source City
              </span>
            </Item>
            <Item sx={{ width: '100%' }}>
              <DropDownOA
                type={Select_Destination_City}
                label={delTransfer ? "Select Source City" : Select_Destination_City}
                data={[cityObj, ...allDataTopSection.SelectDestCity] || []}
                defaultvalue={defaultValueForTop == true ? 'All ' : 'All'}
                width="100%"
                searchPlaceholder={`Search ${Select_Destination_City}`}
                // typeOf={1}
                isObjArr={true}
                dataKey={`CityName`}
                idKey={`CityID`}
                id={'selectDC'}
                tabIndex="4"
                nextId="selectBT"
                prevId={buttonId}
                setAllValue={setSelectedData}
                allValues={selelectedData}
                disabled={cancelEdit == true ? true : false}
              />
            </Item>
            <Item sx={{ width: '100%' }}>
              <DropDownOA
                type={Booking_Type}
                defaultvalue={defaultValueForTop == true ? 'All ' : 'All'}
                // defaultvalue={defaultValueForTop == true ? || 'All'}
                // data={allDataTopSection.BookingType || []}
                data={(allDataTopSection.BookingType || []).map(item => {
                    if (UseToPayAsCOD === 1) {
                      if (item.typeId === 2) return { ...item, name: 'COD' };      
                      if (item.typeId === 7) return { ...item, name: 'COD(MANUAL)' };
                      if (item.typeId === 9) return { ...item, name: 'COD(DDDV)' };
                    }
                    return item;
                  }).filter(item => !(UseToPayAsCOD === 1 && item.typeId === 4))
                }
                width="100%"
                searchPlaceholder={` Search ${Booking_Type}`}
                label={Booking_Type}
                isObjArr={true}
                dataKey={`name`}
                idKey={`typeId`}
                tabIndex="5"
                id="selectBT"
                nextId="selectDB"
                prevId="selectDC"
                setAllValue={setSelectedData}
                allValues={selelectedData}
                disabled={cancelEdit == true ? true : false}
              />
            </Item>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item
              sx={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
                border: BkTransfer ? '2px solid #0086ff' : '1px solid grey',
                margin: '9px',
                height: '39px',
                width: '400px',
                backgroundColor: cancelEdit == true ? '#e0e0e0' : '',
              }}
              onClick={() => handleActive('destCity')}
              disabled={cancelEdit == true ? true : false}
            >
              <LineInput type="radio" checked={BkTransfer} />

              <span
                style={{
                  fontSize: '14px',
                  paddingLeft: '8px',
                  fontWeight: '500',
                  color: 'black',
                }}
              >
                Destination City
              </span>
            </Item>
            <Item sx={{ width: '100%', paddingBottom: '0px' }}>
              <DropDownOA
                type={Select_Destination_Branch}
                defaultvalue={defaultValueForTop == true ? 'All ' : selelectedData.selectDestBranch === "All" ? "All" : selelectedData.selectDestBranch?.BranchName}
                // defaultvalue={defaultValueForTop == true ? 'All ' :"All"}
                label={delTransfer ? "Select Source Branch" : Select_Destination_Branch}
                data={[branchObj, ...filteredDestBranch] || []}
                width="100%"
                searchPlaceholder={`Search ${Select_Destination_Branch}`}
                // typeOf={2}
                isObjArr={true}
                dataKey={`BranchName`}
                idKey={`BranchID`}
                tabIndex="6"
                id="selectDB"
                nextId="selectCT"
                prevId="selectBT"
                setAllValue={setSelectedData}
                allValues={selelectedData}
                disabled={cancelEdit == true ? true : false}
              />
            </Item>
            <Item sx={{ width: '100%', paddingBottom: '0px' }}>
              <DropDownOA
                id="selectCT"
                nextId="show-btn"
                prevId="selectDB"
                type={Consignment_Type}
                defaultvalue={defaultValueForTop == true ? 'All ' : 'All'}
                data={[Consignmentobj, ...cnsgnmntTypes] || []}
                width="100%"
                searchPlaceholder={`Search ${Consignment_Type}`}
                label={Consignment_Type}
                portal={true}
                isObjArr={true}
                dataKey={`SubType`}
                idKey={`ConsignmentSubTypeID`}
                setAllValue={setSelectedData}
                allValues={selelectedData}
                disabled={cancelEdit == true ? true : false}
              />
            </Item>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '100%' }}>
              <Button
                variant="outlined"
                sx={{ width: '100%' }}
                style={{
                  borderColor: cancelEdit == true ? '#cccccc' : '#fe5200',
                  color: '#f15a22',
                  fontSize: '15px',
                  fontWeight: 'bold',
                  textTransform: 'Uppercase',
                }}
                onClick={() => handleActive('CHECKINGREPORT')}
                disabled={cancelEdit == true ? true : false}
              >
                {' '}
                CHECKING REPORT
              </Button>
            </Item>
            <Item sx={{ width: '100%' }}>
              <Button
                onClick={(e) => handleActive('showlist', e)}
                id="show-btn"
                variant="contained"
                sx={{ width: '100%' }}
                style={{
                  backgroundColor: cancelEdit == true ? '#cccccc' : '#fe5200',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                onKeyDown={(e) => onKeyDownn(e)}
                disabled={cancelEdit == true ? true : false}
              >
                {' '}
                SHOW LIST
              </Button>
            </Item>
            <Item sx={{ width: '100%' }}>
              <Button
                variant="contained"
                id="CanceDeliveryCargo"
                sx={{ width: '100%' }}
                style={{
                  backgroundColor: cancelEdit == true ? '#cccccc' : '#fe5200',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                onClick={() => handleActive('showListAll')}
                disabled={cancelEdit == true ? true : false}
              >
                {' '}
                SHOW LIST ALL
              </Button>
            </Item>
          </Box>
        </Item>
      </Stack>
      {showModal && [successModal.CHECKINGREPORT.id].includes(modalType) && CheckingReport(modalType == successModal.CHECKINGREPORT.id)}
      {showModal &&
        [successModal.CHECKINGREPORTPrint.id].includes(modalType) &&
        CheckingReportPrint(modalType == successModal.CHECKINGREPORTPrint.id)}
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateSendCityList,
  updateStrtCity,
  updateBrnchList,
  updateStrtBrnch,
  getBranchList,
  updateModal,
  getCitiesBranchList,
  getAllStates,
  getCheckingReport,
  getListData,
  UpdateListData
}

export default connect(mapStateToProps, mapDispatchToProps)(TopSection)
